import {Component, OnDestroy, OnInit} from '@angular/core';
import {ConfigurationProvider} from "../../configuration/configuration.provider";
import {first, map, tap} from "rxjs/operators";
import {Observable} from "rxjs";
import {CookiesBannerLink} from "../../configuration/configuration.model";
import {CookiesSettingsService} from "../../client/cookies-settings/cookies-settings.service";
import {Router} from "@angular/router";

@Component({
    selector: 'cookies-banner',
    templateUrl: './cookies-banner.component.html',
    styleUrls: ['./cookies-banner.component.scss'],
    standalone: false
})
export class CookiesBannerComponent implements OnInit, OnDestroy {
	items: Observable<{ cookiesSettings: CookiesBannerLink; privacyPolicy: CookiesBannerLink; legalNotices: CookiesBannerLink }>;
	private itemsNumer: number;

	constructor(private configProvider: ConfigurationProvider, private cookiesService: CookiesSettingsService,
				private router: Router) {
	}

	ngOnInit(): void {
		this.items = this.configProvider.getConfiguration().pipe(
			first(),
			tap(config => this.itemsNumer = config.cookieBanner.items.length),
			map(config => {
				return {
					legalNotices: config.cookieBanner.items.find(item => item.id === 'legal-notices'),
					privacyPolicy: config.cookieBanner.items.find(item => item.id === 'privacy-policy'),
					cookiesSettings: config.cookieBanner.items.find(item => item.id === 'cookies-settings'),
				};
			})
		);

		this.cookiesService.onCookieBannerInitialized();
	}

	ngOnDestroy(): void {
		this.cookiesService.onCookieBannerDestroyed();
	}

	acceptCookies() {
		this.cookiesService.acceptAll();
	}

	close() {
		this.cookiesService.rejectAll();
	}

	goToSettings() {
		this.items.pipe(map(config => config.cookiesSettings)).subscribe(settings => {
			if (settings.isRelativeUrl) {
				this.router.navigate([settings.link]);
			} else if(settings.openInSameTab) {
				window.open(settings.link, '_self');
			} else {
				window.open(settings.link, '_blank');
			}
		})
	}

	showSeparator(): boolean {
		return this.itemsNumer > 2;
	}
}
